export default [
  [3, 6, 10, 15, 21, 28, 36, 45, 55, 66, 78, 91, 105, 120, 136, 153, 171, 190],
  [0, 4, 10, 20, 35, 56, 84, 120, 165, 220, 286, 364, 455, 560, 680, 816, 969, 1140],
  [0, 0, 5, 15, 35, 70, 126, 210, 330, 495, 715, 1001, 1365, 1820, 2380, 3060, 3876, 4845],
  [0, 0, 0, 6, 21, 56, 126, 252, 462, 792, 1287, 2002, 3003, 4368, 6188, 8568, 11628, 15504],
  [0, 0, 0, 0, 7, 28, 84, 210, 462, 924, 1716, 3003, 5005, 8008, 12376, 18564, 27132, 38760],

  [0, 0, 0, 0, 0, 8, 36, 120, 330, 792, 1716, 3432, 6435, 11440, 19448, 31824, 50388, 77520],
  [0, 0, 0, 0, 0, 0, 9, 45, 165, 495, 1287, 3003, 6435, 12870, 24310, 43758, 75582, 125970],
  [0, 0, 0, 0, 0, 0, 0, 10, 55, 220, 715, 2002, 5005, 11440, 24310, 48620, 92378, 167960],
  [0, 0, 0, 0, 0, 0, 0, 0, 11, 66, 286, 1001, 3003, 8008, 19448, 43758, 92378, 184756],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 78, 364, 1365, 4368, 12376, 31824, 75582, 167960],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13, 91, 455, 1820, 6188, 18564, 50388, 125970],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 105, 560, 2380, 8568, 27132, 77520],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15, 120, 680, 3060, 11628, 38760],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 136, 816, 3876, 15504],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17, 153, 969, 4845],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 18, 171, 1140],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 19, 190],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20]
]
